import cloneDeep from 'lodash/cloneDeep';

import { getInstance as getBootstrap } from 'utils/bootstrap';

export class Flags {
    constructor(dataSource = getBootstrap().get('flags')) {
        if (typeof dataSource === 'function') {
            /* eslint-disable no-param-reassign */
            dataSource = dataSource();
            /* eslint-enable no-param-reassign */
        }

        if (typeof dataSource === 'object') {
            this._data = dataSource;
        } else if (__TESTING__) {
            this._data = {};
        } else {
            throw new Error('Unsupported flag data type');
        }

        this.bool = (name) => !!this._data[name];
        this.all = () => cloneDeep(this._data);
    }
}

let flagsInstance;

export function getInstance() {
    if (!flagsInstance) {
        flagsInstance = new Flags();
    }
    return flagsInstance;
}

// Can only destroy the instance in tests
export function destroyInstance() {
    if (__TESTING__) {
        flagsInstance = null;
    }
}

export function flag(name) {
    return getInstance().bool(name);
}

export function all() {
    return getInstance().all();
}

export default function flags(name) {
    return name == null ? all() : flag(name);
}
